// Registre partagé des icônes & couleurs de Types de bien (Flotte).
// Réutilisé par Types & catégories, Ma flotte et le Calendrier — zéro duplication.
import { Car, Bike, Gauge, Ship, Sailboat, Anchor, Waves, Plane, Truck, Caravan, Bus, Tractor, Forklift, Zap, Boxes } from "lucide-react";

// Clé stable -> composant lucide. "generic" = fallback type personnalisé.
export const TYPE_ICONS = {
  car: Car, moto: Gauge, bike: Bike, ship: Ship, sailboat: Sailboat, anchor: Anchor,
  waves: Waves, plane: Plane, truck: Truck, caravan: Caravan, bus: Bus,
  tractor: Tractor, forklift: Forklift, electric: Zap, generic: Boxes,
};
export const DEFAULT_TYPE_ICON = "generic";

// Ordre d'affichage dans le sélecteur d'icône
export const ICON_PICKER = [
  "car", "moto", "bike", "ship", "sailboat", "anchor", "waves",
  "plane", "truck", "caravan", "bus", "tractor", "forklift", "electric", "generic",
];

export const TypeIcon = ({ name, className = "h-4 w-4", style }) => {
  const Cmp = TYPE_ICONS[name] || TYPE_ICONS.generic;
  return <Cmp className={className} style={style} />;
};

// Couleurs (clé -> pastille pleine). Aligné sur COLOR_OPTIONS des statuts.
export const TYPE_COLOR_OPTIONS = [
  ["violet", "Violet"], ["emerald", "Vert"], ["blue", "Bleu"], ["sky", "Ciel"],
  ["amber", "Ambre"], ["red", "Rouge"], ["rose", "Rose"], ["teal", "Turquoise"], ["slate", "Gris"],
];
export const TYPE_COLOR_DOT = {
  violet: "bg-violet-500", emerald: "bg-emerald-500", blue: "bg-blue-500", sky: "bg-sky-500",
  amber: "bg-amber-500", red: "bg-red-500", rose: "bg-rose-500", teal: "bg-teal-500", slate: "bg-slate-400",
};
// Valeurs HEX des couleurs prédéfinies — sert aux couleurs personnalisées (#RRGGBB).
export const TYPE_COLOR_HEX = {
  violet: "#8b5cf6", emerald: "#10b981", blue: "#3b82f6", sky: "#0ea5e9",
  amber: "#f59e0b", red: "#ef4444", rose: "#f43f5e", teal: "#14b8a6", slate: "#94a3b8",
};
export const DEFAULT_TYPE_COLOR = "slate";
export const typeColorDot = (c) => TYPE_COLOR_DOT[c] || TYPE_COLOR_DOT.slate;
// Résout une couleur de type (clé prédéfinie OU code HEX personnalisé) en HEX.
export const isCustomColor = (c) => typeof c === "string" && c.startsWith("#");
export const typeColorHex = (c) => (isCustomColor(c) ? c : (TYPE_COLOR_HEX[c] || TYPE_COLOR_HEX.slate));
